const styles = theme => ({
  margin: {
    margin: theme.spacing.unit,
  },
  bottom: {
    verticalAlign: 'bottom',
  },
  paper: {
    padding: 16,
    paddingBottom: 60,
    '@media print': {
      boxShadow: 'none',
      padding: 0
    }
  },
  slider: {
    margin: theme.spacing.unit,
    border: 0,
    display: 'inline-flex',
    padding: 0,
    position: 'relative',
    minWidth: 120,
    width: '100%',
    flexDirection: 'column',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  button: {
    margin: theme.spacing.unit,
  },
  floatingAction: {
    margin: theme.spacing.unit,
    right: 0,
    bottom: 60,
    position: 'absolute',
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/constants/styles.js